const config = {
  apiUrl:
    process.env.REACT_APP_API_URL ||
    'http://backend-stg.wgtmessenger.com/graphql',
};

export default config;
